<template>
	<div class="order-container">
		<div class="head">ORDER</div>
		<div class="title">
			<div :class="['titleSel', reqData.status == 0 ? 'on' : '']" @click="selectState(0)">All </div>
			<div :class="['titleSel', reqData.status == 1 ? 'on' : '']" @click="selectState(1)">To pay</div>
			<div :class="['titleSel', reqData.status == 2 ? 'on' : '']" @click="selectState(2)">To ship</div>
			<div :class="['titleSel', reqData.status == 3 ? 'on' : '']" @click="selectState(3)">Finished</div>
		</div>

		<el-empty description="" v-if="orderList.length==0"></el-empty>
       
		<ul class="orderList">

			<li class="item" v-for="(item,index) in orderList " >
				<div class="orderNum" >
					<div>
						<span class="t">{{moment(item.time*1000).format('MMMM DD,YYYY')}}</span>
						<!-- <span>订单号：{{item.order_sn}}</span> -->
					</div>
					<div class="iconfont" @click="delItem(item,index)"></div>
				</div>
				<div class="cont" @click="gotoDetails(item.id)">
					<div class="goods">
						<div class="img">
							<img :src="item.goods_img" alt="">
						</div>
						<div class="specs">
							<p class="name">{{item.goods_name}}</p>
							<p class="size">Size：{{item.code}}</p>
							<p class="num">Num：{{item.num}}</p>
						</div>
					</div>

					<div class="price">$ {{item.price}}</div>


					<button type="button" class="btn on1" v-if="item.status==1&&item.pay_type!=6" @click="gotoDetails(item.id)">To Pay</button>

					<button type="button" class="btn on1" v-if="item.status==1&&item.pay_type==6" @click="gotoDetails(item.id)">线下支付</button>

					<!-- 待发货 -->
					<button type="button" class="btn on2" v-if="item.status==2" @click="gotoDetails(item.id)">To Ship</button>  

					<button type="button" class="btn on2" v-if="item.status==3" @click="gotoDetails(item.id)">已发货</button>


					<button type="button" class="btn on1" v-if="item.status==4" @click="gotoDetails(item.id)">Finished</button>

				</div>
			</li>

		</ul>
		<div class="page" v-if="orderList.num>10">
			

			<el-pagination background layout="prev, pager, next" :total="total" @current-change="pageChange">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	
	export default {
		data() {
			return {
				reqData: {
					page: 1,
					num: 10,
					status: 0
				},
				loading: true,
				total: 0,
				orderList: [],
			}
		},
		mounted() {

         
			this.getOrderList(this.$route.query.status);
		},
		methods: {
			delItem(item, index) {

				var app = this;

				app.global_variable.dialogConfirm({
					title: 'Tips',
					message: 'Delete this order?',
				}).then(() => {

				   app.$api("/user/orderDelete", {
						order_id: item.id
					}, "POST").then(function(res) {
				        
				        app.global_variable.showToast("Success");
						app.orderList.splice(index, 1)

					})
				})

			},
			getOrderList(status) {

				var app = this;

				if(status){
					app.reqData.status = status;
				}

				app.loading = true;

				this.$api("/user/getOrderList", app.reqData, "POST").then(function(res) {

					app.loading = false;
					app.orderList = res.data.list;
					app.total = res.data.num;

				})
			},
			pageChange(page) {

				this.reqData.page = page;

				this.getOrderList();

			},
			gotoDetails(id) {
				this.$router.push("/orderdetails/" + id)
			},
			selectState(val) {
				this.orderList = [];
				this.reqData = {
					page: 1,
					num: 10,
					status: val
				}

				this.getOrderList();

			}
		}
	}
</script>

<style lang="less" >
	.order-container {
		padding-bottom:50px;

		.title {
			display: flex;
			width: 100%;
			box-sizing: border-box;
			.titleSel {
				flex: 1;
				cursor: pointer;
				font-size: 16px;
				line-height: 50px;
				text-align: center;
				text-align-last: center;
				background-color: #3f3f3f;
				color: #FFF;
				display: inline-block;
			}
			.titleSel:hover,
			.on {
				background-color: #90c31f;
			}
		}
		.page {
			margin-left: 65px;
			text-align: center;
			padding-top: 50px;
		}
		.orderList {
			width: 100%;
			.item {
				margin-top: 38px;
				transition: transform .5s;
				.orderNum {
					padding-bottom: 6px;
					overflow:hidden;
					display:flex;
					align-items:center;
					justify-content: space-between;
					border-bottom: 1px solid #e4e4e5;
					font-size: 16px;
					line-height: 2;
					color: #999;
					.iconfont {
						color: #c1c1c1;
						cursor: pointer;
					}
					.iconfont:hover {
						color: #ea4343;
						
					}
					.iconfont::before {
						content: '\e609';
					}
				}
				.cont {
					padding: 21px 0;
					text-align: justify;
					text-align-last: justify;
					.goods {
						width: 500px;
						text-align: left;
						text-align-last: left;
						display: inline-block;
						.img {
							width: 140px;
							vertical-align: middle;
							display: inline-block;
							img {
								width: 100%;
							}
						}
						.specs {
							margin-left: 44px;
							font-size: 14px;
							line-height: 32px;
							vertical-align: middle;
							color: #999;
							display: inline-block;
							.name {
								width: 300px;
								font-size: 16px;
								color: #0f0e0e;
								cursor: pointer;
							}
						}
					}
					.price {
						width: 100px;
						font-size: 18px;
						text-align: center;
						text-align-last: center;
						color: #0f0e0e;
						display: inline-block;
					}
					.btn {
						width: 80px;
						height: 40px;
						border-radius: 6px;
						font-size: 16px;
						text-align: center;
						text-align-last: center;
						text-align: center;
						color: #999;
						background-color: #e4e4e5;
						opacity: 0;
						pointer-events: none;
						display: inline-block;
					}
					.on1 {
						opacity: 1;
						pointer-events: auto;
						color: #FFF;
						background-color: #ea4343;
					}
					.on2 {
						opacity: 1;
						pointer-events: auto;
						color: #999;
						background-color: #e4e4e5;
					}
				}
				&:hover {
					transform: translate(-1px, -1px);
				}
			}
		}

	}


	@media screen and (max-width:768px) {
		.order-container{
			.title{
				padding-left: 0px;
				.titleSel{
                  line-height:40px;
                  font-size:12px;
				} 
			}
			.page{
			    margin-left: 0px;
			    padding-top: 4%;
			}
			.orderList{
				
				.item{
					margin-top:2%;
					.orderNum{
						font-size:12px;
						line-height:40px;
						padding-bottom:0;
					}
					.iconfont{
						font-size:12px;
					}
					.cont{
						display:flex;
						padding: 20px 0;
						align-items: center;
						.price{
							font-size:12px;
							width:30%;
						}
						.btn{
							padding:0 10px;
							width:auto;
							white-space:nowrap;
							height:25px;
							border-radius:3px;
							font-size:12px;
						}
						.goods{
							width:auto;
							display:flex;
							align-items: center;
							.img{
								flex:0 0 70px;
							}

							.specs{
								padding-left:10px;
								box-sizing:border-box;
								margin-left:0;
								line-height:1.6;
								font-size:12px;
								flex:1;
								.name{
									font-size:12px;
									width:auto;
								}
							}
						}
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Order.vue